"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Asterisk = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _templateObject;

var Asterisk = _styledComponents["default"].span.attrs({
  children: '*'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    margin-right: 4px;\n    color: ", ";\n    font-size     : ", "px;\n"])), function (_ref) {
  var error = _ref.error;
  return error ? _palette.palette.error : 'inherit';
}, function (_ref2) {
  var status = _ref2.status;
  return status === 'default' ? 16 : 14;
});

exports.Asterisk = Asterisk;